import { defineMessages } from "react-intl";
import compact from "lodash/compact";

import { formatDate } from "../../helpers/DateTimeHelper";
import parseDate from "./parseDate";
import { useIntl } from "../Intl/Context";

export default function dateRangeMessage(
  intl,
  startDateInput,
  endDateInput,
  options = {}
) {
  const { formatMessage } = intl;

  const startDate = startDateInput && parseDate(startDateInput);
  const endDate = endDateInput && parseDate(endDateInput);
  const formattedStartDate = startDate && formatDate(intl, startDate);
  const formattedEndDate = endDate && formatDate(intl, endDate);

  const labels = {
    fromStartDate: formatMessage(intlMessages.fromStartDate, {
      date: formattedStartDate
    }),
    untilEndDate: formatMessage(intlMessages.untilEndDate, {
      date: formattedEndDate
    }),
    startDate: formatMessage(intlMessages.startDate, {
      date: formattedStartDate
    }),
    endDate: formatMessage(intlMessages.endDate, {
      date: formattedEndDate
    })
  };

  const startDateMessage = startDate && labels[endDate ? "startDate" : "fromStartDate"];
  const endDateMessage = endDate && labels[startDate ? "endDate" : "untilEndDate"];

  return compact([startDateMessage, endDateMessage]).join(options.separator || " ");
}

export const useDateRangeMessage = () => {
  const intl = useIntl();
  return (...args) => dateRangeMessage(intl, ...args);
};

const intlMessages = defineMessages({
  fromStartDate: {
    id: "dateRangeMessage.fromStartDate",
    defaultMessage: "À partir du {date}"
  },
  untilEndDate: {
    id: "dateRangeMessage.untilEndDate",
    defaultMessage: "Jusqu'au {date}"
  },
  startDate: {
    id: "dateRangeMessage.startDate",
    defaultMessage: "Du {date}"
  },
  endDate: {
    id: "dateRangeMessage.endDate",
    defaultMessage: "au {date}"
  }
});
